import React from "react";
import _ from 'i18n';
import { Col, Row, Tooltip } from "antd";
import { formatAmount } from "../../../services/utils";
import EventPiechart from "./EventPieChart";


const EventCharts = ({ event }) => {
  if (!event) return null;

  let [totalOrder, totalInvoices, invoiceAmount, creditNoteAmount, totalCanceledOrder, totalValidOrder, totalPaidInvoice, totalUnpaidInvoice, caHorsTva, caTvaInclu, caTva, pricePerRegistrant, tauxPayment, cyclesCA, pricePerRegistrantHTVA] = Array(15).fill(0);

  if (event && event.stats) {
    totalOrder = (event.stats['order'] && event.stats['order']['NOT_PAID'] ? parseInt(event.stats['order']['NOT_PAID'].count) : 0) + (event.stats['order'] && event.stats['order']['PAID'] ? parseInt(event.stats['order']['PAID'].count) : 0) + (event.stats['order'] && event.stats['order']['OVER_PAID'] ? parseInt(event.stats['order']['OVER_PAID'].count) : 0) + (event.stats['order'] && event.stats['order']['UNDER_PAID'] ? parseInt(event.stats['order']['UNDER_PAID'].count) : 0)
    totalInvoices = (event.stats['invoice'] && event.stats['invoice']['PAID'] ? parseInt(event.stats['invoice']['PAID'].count) : 0) + (event.stats['invoice'] && event.stats['invoice']['OVER_PAID'] ? parseInt(event.stats['invoice']['OVER_PAID'].count) : 0) + (event.stats['invoice'] && event.stats['invoice']['NOT_PAID'] ? parseInt(event.stats['invoice']['NOT_PAID'].count) : 0);
    invoiceAmount = (event.stats['invoice'] && event.stats['invoice']['PAID'] ? parseInt(event.stats['invoice']['PAID'].including_vat_amount) : 0) + (event.stats['invoice'] && event.stats['invoice']['OVER_PAID'] ? parseInt(event.stats['invoice']['OVER_PAID'].including_vat_amount) : 0) + (event.stats['invoice'] && event.stats['invoice']['NOT_PAID'] ? parseInt(event.stats['invoice']['NOT_PAID'].including_vat_amount) : 0);
    creditNoteAmount = (event.stats['credit_note'] && event.stats['credit_note']['REFUNDED'] ? parseInt(event.stats['credit_note']['REFUNDED'].including_vat_amount) : 0) + (event.stats['credit_note'] && event.stats['credit_note']['NOT_REFUNDED'] ? parseInt(event.stats['credit_note']['NOT_REFUNDED'].including_vat_amount) : 0);

    totalCanceledOrder = event.stats['1'] ? event.stats['1'].count : 0;
    totalValidOrder = event.stats['0'] ? event.stats['0'].count : 0;

    totalPaidInvoice = event.stats['invoice'] ? (event.stats['invoice']['PAID'] ? parseInt(event.stats['invoice']['PAID'].including_vat_amount) : 0) + (event.stats['invoice']['OVER_PAID'] ? parseInt(event.stats['invoice']['OVER_PAID'].including_vat_amount) : 0) : 0;
    totalUnpaidInvoice = event.stats['invoice'] ? (event.stats['invoice']['NOT_PAID'] ? parseInt(event.stats['invoice']['NOT_PAID'].including_vat_amount) : 0) : 0;
    caHorsTva = (event.stats['invoice'] && event.stats['invoice']['PAID'] ? parseInt(event.stats['invoice']['PAID'].excluding_vat_amount) : 0) + (event.stats['invoice'] && event.stats['invoice']['OVER_PAID'] ? parseInt(event.stats['invoice']['OVER_PAID'].excluding_vat_amount) : 0) + (event.stats['invoice'] && event.stats['invoice']['NOT_PAID'] ? parseInt(event.stats['invoice']['NOT_PAID'].excluding_vat_amount) : 0) + (event.stats['invoice'] && event.stats['invoice']['UNDER_PAID'] ? parseInt(event.stats['invoice']['UNDER_PAID'].excluding_vat_amount) : 0) - ((event.stats['credit_note'] && event.stats['credit_note']['REFUNDED'] ? parseInt(event.stats['credit_note']['REFUNDED'].excluding_vat_amount) : 0) + (event.stats['credit_note'] && event.stats['credit_note']['NOT_REFUNDED'] ? parseInt(event.stats['credit_note']['NOT_REFUNDED'].excluding_vat_amount) : 0));
    caTvaInclu = invoiceAmount - creditNoteAmount;
    caTva = caTvaInclu - caHorsTva;

    if (event.stats['cyclesCAInfos']) {
      event.stats['cyclesCAInfos'].forEach(cycleCAInfo => {
        let cycleInvoiceAmount = (cycleCAInfo['CA']['invoice'] && cycleCAInfo['CA']['invoice']['PAID'] ? parseInt(cycleCAInfo['CA']['invoice']['PAID'].including_vat_amount) : 0) + (cycleCAInfo['CA']['invoice'] && cycleCAInfo['CA']['invoice']['OVER_PAID'] ? parseInt(cycleCAInfo['CA']['invoice']['OVER_PAID'].including_vat_amount) : 0) + (cycleCAInfo['CA']['invoice'] && cycleCAInfo['CA']['invoice']['NOT_PAID'] ? parseInt(cycleCAInfo['CA']['invoice']['NOT_PAID'].including_vat_amount) : 0)
        let cycleCreditNoteAmount = (cycleCAInfo['CA']['credit_note'] && cycleCAInfo['CA']['credit_note']['REFUNDED'] ? parseInt(cycleCAInfo['CA']['credit_note']['REFUNDED'].including_vat_amount) : 0) + (cycleCAInfo['CA']['credit_note'] && cycleCAInfo['CA']['credit_note']['NOT_REFUNDED'] ? parseInt(cycleCAInfo['CA']['credit_note']['NOT_REFUNDED'].including_vat_amount) : 0);
        cyclesCA += (cycleInvoiceAmount - cycleCreditNoteAmount) / cycleCAInfo['formationCount'];
      })
    }

    // pricePerRegistrant = event && event.moyenPricePerRegistrant ? event.moyenPricePerRegistrant : 0;
    // pricePerRegistrantHTVA = event && event.moyenPricePerRegistrantHTVA ? event.moyenPricePerRegistrantHTVA : 0;


    //  pricePerRegistrantHTVA = event && event.paidRegistrant ? (caHorsTva/100)/event.paidRegistrant : 0;
    //  pricePerRegistrant = event && event.paidRegistrant ? (caTvaInclu/100)/event.paidRegistrant:0;

    pricePerRegistrantHTVA = event && event.moyenPricePerRegistrantHTVA ? event.moyenPricePerRegistrantHTVA : 0;
    pricePerRegistrant = event && event.moyenPricePerRegistrant ? event.moyenPricePerRegistrant : 0;
    tauxPayment = event && event.tauxPayment ? event.tauxPayment : 0;

  } else {
    let totalRegistrants = 0;
    let hasPaidUserIds = [];
    let uniqueHasPaidUserIds = [];

    for (const property in event) {
      if (event && event[property] && event[property].stats) {
        totalRegistrants += parseInt(event[property].paidRegistrant) + parseInt(event[property].notPaidRegistrant);
        // totalPaidRegistrants += parseInt(event[property].paidRegistrant);

        hasPaidUserIds = [...hasPaidUserIds, ...event[property].hasPaidUserIds];


        totalOrder += (event[property].stats['order'] && event[property].stats['order']['NOT_PAID'] ? parseInt(event[property].stats['order']['NOT_PAID'].count) : 0) + (event[property].stats['order'] && event[property].stats['order']['PAID'] ? parseInt(event[property].stats['order']['PAID'].count) : 0) + (event[property].stats['order'] && event[property].stats['order']['OVER_PAID'] ? parseInt(event[property].stats['order']['OVER_PAID'].count) : 0) + (event[property].stats['order'] && event[property].stats['order']['UNDER_PAID'] ? parseInt(event[property].stats['order']['UNDER_PAID'].count) : 0)
        totalInvoices += (event[property].stats['invoice'] && event[property].stats['invoice']['PAID'] ? parseInt(event[property].stats['invoice']['PAID'].count) : 0) + (event[property].stats['invoice'] && event[property].stats['invoice']['OVER_PAID'] ? parseInt(event[property].stats['invoice']['OVER_PAID'].count) : 0) + (event[property].stats['invoice'] && event[property].stats['invoice']['NOT_PAID'] ? parseInt(event[property].stats['invoice']['NOT_PAID'].count) : 0)

        invoiceAmount += (event[property].stats['invoice'] && event[property].stats['invoice']['PAID'] ? parseInt(event[property].stats['invoice']['PAID'].including_vat_amount) : 0) + (event[property].stats['invoice'] && event[property].stats['invoice']['OVER_PAID'] ? parseInt(event[property].stats['invoice']['OVER_PAID'].including_vat_amount) : 0) + (event[property].stats['invoice'] && event[property].stats['invoice']['NOT_PAID'] ? parseInt(event[property].stats['invoice']['NOT_PAID'].including_vat_amount) : 0);
        creditNoteAmount += (event[property].stats['credit_note'] && event[property].stats['credit_note']['REFUNDED'] ? parseInt(event[property].stats['credit_note']['REFUNDED'].including_vat_amount) : 0) + (event[property].stats['credit_note'] && event[property].stats['credit_note']['NOT_REFUNDED'] ? parseInt(event[property].stats['credit_note']['NOT_REFUNDED'].including_vat_amount) : 0);

        totalCanceledOrder += event[property].stats['1'] ? parseInt(event[property].stats['1'].count) : 0
        totalValidOrder += event[property].stats['0'] ? parseInt(event[property].stats['0'].count) : 0

        totalPaidInvoice += event[property].stats['invoice'] ? (event[property].stats['invoice']['PAID'] ? parseInt(event[property].stats['invoice']['PAID'].including_vat_amount) : 0) + (event[property].stats['invoice']['OVER_PAID'] ? parseInt(event[property].stats['invoice']['OVER_PAID'].including_vat_amount) : 0) : 0;
        totalUnpaidInvoice += event[property].stats['invoice'] ? (event[property].stats['invoice']['NOT_PAID'] ? parseInt(event[property].stats['invoice']['NOT_PAID'].including_vat_amount) : 0) : 0;

        caHorsTva += (event[property].stats['invoice'] && event[property].stats['invoice']['PAID'] ? parseInt(event[property].stats['invoice']['PAID'].excluding_vat_amount) : 0) + (event[property].stats['invoice'] && event[property].stats['invoice']['OVER_PAID'] ? parseInt(event[property].stats['invoice']['OVER_PAID'].excluding_vat_amount) : 0) + (event[property].stats['invoice'] && event[property].stats['invoice']['NOT_PAID'] ? parseInt(event[property].stats['invoice']['NOT_PAID'].excluding_vat_amount) : 0) + (event[property].stats['invoice'] && event[property].stats['invoice']['UNDER_PAID'] ? parseInt(event[property].stats['invoice']['UNDER_PAID'].excluding_vat_amount) : 0) - ((event[property].stats['credit_note'] && event[property].stats['credit_note']['REFUNDED'] ? parseInt(event[property].stats['credit_note']['REFUNDED'].excluding_vat_amount) : 0) + (event[property].stats['credit_note'] && event[property].stats['credit_note']['NOT_REFUNDED'] ? parseInt(event[property].stats['credit_note']['NOT_REFUNDED'].excluding_vat_amount) : 0));
        caTvaInclu = invoiceAmount - creditNoteAmount;
        caTva = caTvaInclu - caHorsTva;

        // pricePerRegistrant += event[property].moyenPricePerRegistrant ? ( parseInt(event[property].paidRegistrant)+ parseInt(event[property].notPaidRegistrant)) * parseInt(event[property].moyenPricePerRegistrant) : 0;
        // pricePerRegistrantHTVA += event[property].moyenPricePerRegistrantHTVA ? ( parseInt(event[property].paidRegistrant)+ parseInt(event[property].notPaidRegistrant)) * parseInt(event[property].moyenPricePerRegistrantHTVA) : 0;
        tauxPayment += event[property].tauxPayment ? (parseInt(event[property].paidRegistrant) + parseInt(event[property].notPaidRegistrant)) * parseFloat(event[property].tauxPayment) : 0;
      }
    }

    uniqueHasPaidUserIds = [...new Set(hasPaidUserIds)];

    tauxPayment = tauxPayment / totalRegistrants;
    // pricePerRegistrant = pricePerRegistrant / totalPaidRegistrants;
    // pricePerRegistrantHTVA = pricePerRegistrantHTVA / totalPaidRegistrants;

    pricePerRegistrant = uniqueHasPaidUserIds.length !== 0 ? (caTvaInclu / 100) / uniqueHasPaidUserIds.length : 0;
    pricePerRegistrantHTVA = uniqueHasPaidUserIds.length !== 0 ? (caHorsTva / 100) / uniqueHasPaidUserIds.length : 0;
  }

  return (
    <Row className="event-stats-charts event-stats-global-charts">
      <Col span={6}>
        <div className="event-stats-chart-bloc">
          <div className="event-stats-chart-title">
            {_('CA')}
          </div>
          <Row>
            <Col span={8} offset={1}>
              <img src={"/img/icons/CA-ICON.svg"} className="event-stats-chart-img" />
            </Col>
            <Col span={15}>
              <div className={'mt-2 mb-1'}>
                <label className="event-stats-chart-label">
                  {_('HTVA') + ' :'}
                </label>
                <span className="event-stats-title"> {formatAmount(caHorsTva)}</span>
              </div>
              <div className={'mb-1'}>
                <label className="event-stats-chart-label">
                  {_('TVA') + ' :'}
                </label>
                <span className="event-stats-title"> {formatAmount(caTva)}</span>
              </div>
              <div>
                <label className="event-stats-chart-label">
                  {_('TOTAL')} :
                </label>
                <span className="event-stats-title"> {formatAmount(caTvaInclu)}</span>
              </div>
              {
                event.nbrFormation == 0 &&
                <div className={'mt-1'}>
                  <label className="event-stats-chart-label">
                    <Tooltip placement="topLeft" title={_('CA_FROM_CYCLES')} arrowPointAtCenter>
                      {_('cycle_registering') + ' :'}
                    </Tooltip>
                  </label>
                  <span className="event-stats-title"> {formatAmount(cyclesCA)}</span>
                </div>
              }
            </Col>
          </Row>
        </div>
      </Col>
      <Col span={6}>
        <div className="event-stats-chart-bloc">
          <div className="event-stats-chart-title">
            {_('Order')}
          </div>
          <Row>
            <Col span={8} offset={1}>
              <EventPiechart total={totalOrder} count={totalValidOrder} color={'#03B593'} pieColor={'#FE3745'} style={{ opacity: 1 }} />
            </Col>
            <Col span={15}>
              <div className={'flex justify-center items-center'}>
                <div className={'event-stats-green-span'}>
                  {totalValidOrder} {_('VALID')}
                </div>
              </div>
              <div className={'flex justify-center items-center'}>
                <div className={'event-stats-red-span'}>
                  {totalCanceledOrder} {_('CANCELED')}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
      <Col span={6}>
        <div className="event-stats-chart-bloc">
          <div className="event-stats-chart-title">
            {_('invoice')}
          </div>
          <Row>
            <Col span={8} offset={1}>
              <EventPiechart total={totalInvoices} count={totalInvoices} color={'#03B593'} pieColor={'#FE3745'} />
            </Col>
            <Col span={15}>
              <div className={'flex justify-center items-center'}>
                <div className={'event-stats-green-span'}>
                  {formatAmount(totalPaidInvoice) + ' ' + _('PAID')}
                </div>
              </div>
              <div className={'flex justify-center items-center'}>
                <div className={'event-stats-red-span'}>
                  {formatAmount(totalUnpaidInvoice) + ' ' + _('NOT_PAID')}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
      <Col span={6}>
        <div className="event-stats-chart-bloc">
          <div className="event-stats-chart-title">
            {_('PAYOUT_RATE')}
          </div>
          <Row>
            <Col span={8} offset={1}>
              <EventPiechart total={100} count={tauxPayment ? tauxPayment : 0} color={'#29394D'} pieColor={'#D8DDE2'} countRappel={tauxPayment ? tauxPayment.toFixed(2) + '%' : '0%'} />
            </Col>
            <Col span={15}>
              <div className={'flex justify-start items-center'}>
                <div className={'event-stats-span'}>
                  {_('AVERAGE_PRICE')}
                </div>
              </div>
              <div className={'mt-2 mb-1'}>
                <label className="event-stats-chart-label">
                  {_('TVAC') + ' :'}
                </label>
                <span className="event-stats-title"> {pricePerRegistrant ? formatAmount(pricePerRegistrant * 100) : formatAmount(0)}</span>
              </div>
              <div className={'mt-2 mb-1'}>
                <label className="event-stats-chart-label">
                  {_('HTVA') + ' :'}
                </label>
                <span className="event-stats-title"> {pricePerRegistrantHTVA ? formatAmount(pricePerRegistrantHTVA * 100) : formatAmount(0)}</span>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
}

export default EventCharts;


// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventCharts.js